import React from 'react';

const CallToAction = () => {
  return (
   <section
  className="section text-center"
  style={{
    position: "relative",
    padding: "80px 0",
    overflow: "hidden",
  }}
>
  {/* Background Video */}
  <video
    autoPlay
    loop
    muted
    playsInline
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      zIndex: 1,
    }}
  >
    <source src="/images/projects/getin.mp4" type="video/mp4" />
  </video>

  {/* Dark Overlay (optional for readability) */}
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.4)", // 0.4 darkness
      zIndex: 2,
    }}
  ></div>

  {/* Content */}
  <div className="container" style={{ position: "relative", zIndex: 3 }}>
    <p className="lead text-light mb-2">Driving Next-Gen Growth</p>
    <h2 className="text-13 font-weight-400 text-white mb-1">
    Engineering your Smart Future With Us 
    </h2>
    <h2 className="text-6
       font-weight-600 text-white mb-4">
     Forge Strategic Market Leadership.
    </h2>
    <a
      href="#contact"
      className="btn btn-outline-light rounded-pill smooth-scroll mt-2"
    >
      GetStarted
    </a>
  </div>
</section>

  );
};

export default CallToAction;
